module.exports = __webpack_public_path__ + "static/img/1_2_2_4.b8a26bf5.jpg";